import './Description.css'

export function ProductDescription({ product }) {
  return (
    <div className="product-description">
      <h2>Descripción</h2>
      <p>{product?.descripcion || product?.description}</p>
    </div>
  )
}